import React, { useState, useEffect, useCallback, useContext,useRef } from "react";
import QuoteSearchForm from "./QuoteSearchForm";
import QuoteList from "./QuoteList";
import { useNavigation } from "react-router-dom";
import QuoteItem from "./QuoteItem";
import useHttp from "../../hooks/use-http";
import { SetAnalyticsData } from '../../util/SetAnalyticsData';

import styles from "./QuoteHistory.module.css";
import Button from "../UI/Button";
import AppContext from "../../store/app-context";

const QuoteHistory = (props) => {
  const navigation = useNavigation();

  const appCtx = useContext(AppContext);

  sessionStorage.removeItem("webReference");
  sessionStorage.removeItem("acctInfo");
  sessionStorage.removeItem("quote");

  const {
    isLoadingGetQuote,
    errorGetQuote,
    sendRequest: getQuoteList,
  } = useHttp();
  const [isLoading, setIsLoading] = useState(true);
  const [quoteList, setQuoteList] = useState([]);
  const [isAPIError, setIsAPIError] = useState(false);
  const [searchErrorMsg, setSearchErrorMsg] = useState();
  const [fetchErroMessage, setFetchErrorMessage] = useState();
  const [displayShowAllButton, setDisplayShowAllButton] = useState(false);
  const [searchResult, setSearchResult] = useState();
  const hasLoaded = useRef(false);

  const searchHandler = useCallback(async (searchCriteria, fromSearch) => {
    //console.log("searchCriteria: " + JSON.stringify(searchCriteria));
    setSearchErrorMsg(null);
    setIsLoading(true);
    setDisplayShowAllButton(false);

    const setQuotes = (quotes) => {
      const qeVoList = quotes && quotes.qeVoList ? quotes.qeVoList : null;
      const quoteItemList = qeVoList.map((quote, _id) => (
        <QuoteItem
          webReference={quote.webReference}
          quoteId={quote.quoteId}
          name={quote.name}
          expiryDate={quote.formattedExpiryDate}
          status={quote.quoteStatus}
          background={_id % 2 === 0 ? "background1" : "background2"}
        />
      ));
      setQuoteList(quoteItemList);

      if(quotes){
        setSearchResult(quotes);
      }

      setIsLoading(false);
    };

    if (fromSearch &&
      (!searchCriteria ||
      (!searchCriteria.qid &&
        !searchCriteria.webRef &&
        !searchCriteria.dateStart &&
        !searchCriteria.dateEnd &&
        !searchCriteria.status))
    ) {
      setSearchErrorMsg("Please select at least one search criteria");
      setIsLoading(false);
      return;
    }

    const qidParam = "qid=" + (searchCriteria.qid ? searchCriteria.qid : "");
    const webRefParam =
      "&webRef=" + (searchCriteria.webRef ? searchCriteria.webRef : "");
    const dateStartParam =
      "&dateS=" + (searchCriteria.dateStart ? searchCriteria.dateStart : "");
    const dateEndParam =
      "&dateE=" + (searchCriteria.dateEnd ? searchCriteria.dateEnd : "");
    const statusParam =
      "&status=" + (searchCriteria.status ? searchCriteria.status : "");
    const sizeParam =
      "&size=" + (searchCriteria.size ? searchCriteria.size : 10);
    const pageParam =
      "&page=" + (searchCriteria.page ? searchCriteria.page : 1);

    const searchServiceURL =
      "/quoteservices/rfqs/search2?" +
      qidParam +
      webRefParam +
      dateStartParam +
      dateEndParam +
      statusParam +
      sizeParam +
      pageParam;

    const response = await fetch(searchServiceURL);

    if (!response.ok) {
      //setIsAPIError(true);
      setIsLoading(false);
      const data = await response.json();
      if (data && data.status === "fail") {
        setSearchErrorMsg(data.message);
      } else {
        setSearchErrorMsg("Error fetching quotes");
      }
      setQuoteList([]);
    } else {
      const data = await response.json();
      if (data && data.status === "fail") {
        setSearchErrorMsg(data.message);
        setQuoteList([]);
      } else {
        setQuotes(data);
      }
    }
    setIsLoading(false);
    setDisplayShowAllButton(true);
  }, []);

  const cntryLang = appCtx.lang.toLowerCase()+"-" +appCtx.country.toLowerCase(); 

  useEffect(() => {
    setIsLoading(true);
    const setQuotes = (quotes) => {
      const qeVoList = quotes && quotes.qeVoList ? quotes.qeVoList : null;
      const quoteItemList = qeVoList.map((quote, _id) => (
        <QuoteItem
          webReference={quote.webReference}
          quoteId={quote.quoteId}
          name={quote.name}
          expiryDate={quote.formattedExpiryDate}
          status={quote.quoteStatus}
          background={_id % 2 === 0 ? "background1" : "background2"}
        />
      ));
      setQuoteList(quoteItemList);

      if(quotes){
        setSearchResult(quotes);
      }

      setIsLoading(false);
    };

    getQuoteList(
      { url: "/quoteservices/rfqs/search2" },
      setQuotes,
      "json"
    ).catch((error) => {
      setIsAPIError(true);
      setFetchErrorMessage(error.message);
      setIsLoading(false);
    });
  }, [getQuoteList]);


  const showAllHandler =  useCallback(async () => {
    setIsLoading(true);
    setDisplayShowAllButton(false);
    const setQuotes = (quotes) => {
      const qeVoList = quotes && quotes.qeVoList ? quotes.qeVoList : null;
      const quoteItemList = qeVoList.map((quote, _id) => (
        <QuoteItem
          webReference={quote.webReference}
          quoteId={quote.quoteId}
          name={quote.name}
          expiryDate={quote.formattedExpiryDate}
          status={quote.quoteStatus}
          background={_id % 2 === 0 ? "background1" : "background2"}
        />
      ));
      setQuoteList(quoteItemList);

      if(quotes){
        setSearchResult(quotes);
      }

      setIsLoading(false);
    };

    const savedQuotesURL = "/quoteservices/rfqs/search2";
    const response = await fetch(savedQuotesURL);

    if (!response.ok) {
      setIsAPIError(true);
      //setIsLoading(false);
      const data = await response.json();
      if(data && data.status === 'fail'){
        setFetchErrorMessage(data.message);
      }
    }else{
      const data = await response.json();
      if(data && data.status === 'fail'){
        setFetchErrorMessage(data.message);
        //setIsLoading(false);
      }else{
        setQuotes(data);
      }
    }
    setIsLoading(false);
  },[]);

  const paginationHandler = (nextPage) => {
    if(searchResult && searchResult.searchParams) {
      const searchParams = searchResult.searchParams;
      const pageNo = searchParams.page ? searchParams.page + nextPage : 1;
      searchParams['page'] = pageNo;
      searchHandler(searchParams, false);
    }
  }
  
  // Adobe Analytics: userView and pageView
  SetAnalyticsData();
  
  return (
    <div className={styles.history}>
      <h1>Quote History</h1>
      <QuoteSearchForm onSearch={searchHandler} errorMsg={searchErrorMsg} />
      {navigation.state === "loading" && (
        <p className={styles.loading_ring}></p>
      )}
      {isLoading && !isAPIError && <p className={styles.loading_ring}></p>}

      {!isLoading && !isAPIError && quoteList && quoteList.length > 0 && (
        <QuoteList quoteList={quoteList} />
      )}
      {isAPIError && <p>{fetchErroMessage}</p>}

      {/*
        <div className={styles.btn_showmore}>
        {!isLoading && displayShowAllButton && (
          <Button onClick={showAllHandler}>Show All</Button>
        )}
      </div>
        */}
      {!isLoading && !isAPIError && quoteList && quoteList.length > 0 && (
        <div className={styles.pagination}>
          <ul className={styles.pagination_items}>
            {searchResult && searchResult.page && (searchResult.page > 1) && (
                <li className={styles.page_item__next}>
                  <a href="#" title="Go to prev page" rel="prev" onClick={() => paginationHandler(-1)}>
                    <span className="visually-hidden">Prev page</span>
                    <span aria-hidden="true">‹</span>
                  </a>
                </li>
              )}
            <li className={styles.page_item_prefix}>
              <span aria-hidden="true" role="presentation">
                Page{" "}
                <b>
                  {searchResult && searchResult.page
                    ? searchResult.page
                    : 1}
                </b>{" "}
                of{" "}
                {searchResult && searchResult.totalPage
                  ? searchResult.totalPage
                  : 1}
              </span>
            </li>
            {searchResult && searchResult.totalPage && searchResult.page && (searchResult.page < searchResult.totalPage) && (
              <li className={styles.page_item__next}>
                <a href="#" title="Go to next page" rel="next" onClick={() => paginationHandler(1)}>
                  <span className="visually-hidden">Next page</span>
                  <span aria-hidden="true">›</span>
                </a>
              </li>
            )}
          </ul>
        </div>
      )}
    </div>
  );
};

export default QuoteHistory;
